import Vue from 'vue'
import 'normalize.css/normalize.css'
import 'lib-flexible'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

//解决打包后，样式被覆盖的问题
import App from './App.vue'
import router from '../router/router'

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
